<template>
  <div class="row row--mb-20">
    <div class="col-sm-12">
      <h2 class="section-header">
        <contentful-text :item="contentfulText('checkout-download-animated-image-head')" />
      </h2>
      <div class="row">
        <div class="col-sm-6">
          <p>
            <contentful-text :item="contentfulText('checkout-download-animated-image-lede')" />
          </p>
          <p>
            <a
              :href="viewModel.AnimatedImageDownloadUrl"
              class="button button--cta"
              target="_blank"
              @click="trackClick"
            >
              <contentful-text :item="contentfulText('checkout-download-animated-image-download-button-label')" />
              <div
                draggable="false"
                class="button__image button__image--download"
              />
            </a>
          </p>
        </div>

        <div class="col-sm-6">
          <h4>
            <contentful-text :item="contentfulText('checkout-download-animated-image-sample-image-label')" />
          </h4>
          <contentful-image
            :item="contentfulImage('checkout-download-animated-image-sample-image')"
            :classes="['animated-image__sample-image']"
          />
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import GoogleAnalytics from '@Shared/lib/google-analytics'

export default {
  name: 'AnimatedImage',
  computed: {
    siteRoot () {
      return this.$store.state.siteRoot
    },
    viewModel () {
      return this.$store.state.viewModel
    },
    sampleImageUrl () {
      return `${this.siteRoot}assets/responsive/gradimages/img/samples/animation-2016-sample.gif`
    },
    content () {
      return this.viewModel.PageContent
    }
  },
  methods: {
    trackClick () {
      GoogleAnalytics.trackEvent('DigitalImageDownload', 'Image', 'Animated')
    }
  }
}
</script>

<style lang="scss" scoped>
.animated-image {
  &__sample-image {
    width: 150px;
    height: 150px;
  }
}

.row--mb-20 {
  margin-bottom: 20px;
}
</style>



// WEBPACK FOOTER //
// WebResources/vue/grad-images/checkout-download/components/AnimatedImage.vue